<!-- type = tile - Icons smaller without border -->
<div class="tile" *ngIf="type === 'tile'">
  <i class="icon-btn-more more-option"></i>
  <div [class.active]="status==='hoverOn'">
    <a class="stagger-elem" (click)="onDownload()" *ngIf="asset.contentType !== typeVideo">
      <i class="icon-download" title="Download" ></i>
    </a>
    <a class="stagger-elem" (click)="share()">
      <i class="stagger-elem icon-share" title="Share"></i>
    </a>
  </div>
</div>

<!-- type = viewer - Icons bigger with border -->
<div class="viewer" *ngIf="type === 'viewer'">
  <ul class="navbar-nav ml-auto topic-controls">
	  <li class="nav-item stagger-elem">
      <a class="nav-link float-right p-0 cursor" (click)="onDownload()" *ngIf="asset.contentType !== typeVideo">
        <span><i class="icon icon-download-circle" aria-hidden="true"></i></span>
      </a>
	  </li>
	  <li class="nav-item stagger-elem">
      <a class="nav-link float-right p-0" (click)="share()">
        <span><i class="icon icon-share-circle" aria-hidden="true"></i></span>
      </a>
	  </li>
	<!--  <li class="nav-item stagger-elem">
      <a class="nav-link float-right p-0" (click)="contact()">
        <span><i class="icon icon-ask-question-circle" aria-hidden="true"></i></span>
      </a>
	  </li>-->
	</ul>
</div>

<!-- type = dropdown - Dropdown menu-->
<div class="dropdown" *ngIf="type === 'dropdown'">
  <div class="btn-group" dropdown [isOpen]="statusDropdown.isopen" [autoClose]="true" (isOpenChange)="change($event)" container="body">
    <a dropdownToggle  class="nav-link" [routerLink]="" (click)="toggleDropdown($event)">
      <span><i class="icon icon-btn-more" [ngClass]="{'text-primary': statusDropdown.isopen}"  aria-hidden="true"></i></span>
    </a>
    <ul *dropdownMenu class="dropdown-menu bg-dark text-light" role="menu">
      <!-- <li role="menuitem"><a class="dropdown-item text-secondary" (click)="download()">Download Set <span class="font-weight-light">({{ asset?.size | fileSize: 'MB' }})</span></a></li> -->
      <li role="menuitem"><a class="dropdown-item text-secondary" (click)="share()">Share Set </a></li>
     <!-- <li role="menuitem"><a class="dropdown-item text-secondary" (click)="contact()">Ask Question About Set </a></li>-->
    </ul>
  </div>
</div>
